import React, { useState } from "react";

export const CompactTestResultCard: React.FC<{ data: any }> = ({ data }) => {
  const [showDetails, setShowDetails] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  return (
    <div className="bg-white border rounded-2xl shadow-sm p-4 w-full">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
         <div className="flex items-start gap-1">
            <h3 className="text-sm font-semibold">Test Results</h3>
            <div className="relative"
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
            >
              <span className="inline-flex items-center justify-center w-4.5 h-4.5 rounded-full bg-blue-100 border border-blue-400 text-blue-600 text-[10px] font-bold cursor-help leading-none select-none px-1 py-0.5">i</span>
              {showTooltip && (
                <div className="absolute top-full left-0 mt-1 w-48 bg-gray-800 text-white text-xs rounded px-2 py-1 z-10 whitespace-normal">
                  75% is the threshold value to push policy
                </div>
              )}
            </div>
          </div>
          <p className="text-xs text-gray-500">
            {data.total_tests} tests • {data.execution_time.toFixed(3)}s
          </p>
        </div>

        <span
          className={`px-3 py-1 text-xs rounded-full font-medium text-white ${
            data.all_passed ? "bg-green-600" : "bg-red-600"
          }`}
        >
          {data.all_passed ? "PASSED" : "FAILED"}
        </span>
      </div>

      {/* Stats */}
      <div className="flex justify-between mt-4 text-sm">
        <Stat label="Passed" value={data.passed_tests} color="green" />
        <Stat label="Failed" value={data.failed_tests} color="red" />
        <Stat label="Retries" value={data.retry_count} color="black" />
      </div>

      {/* Progress */}
      <div className="mt-3">
        <div className="w-full bg-gray-200 rounded-full h-2">
          <div
            className={`h-2 rounded-full transition-all duration-500 ${
             data.success_rate >= 50 && data.success_rate < 75 ? "bg-blue-500" : data.success_rate >= 75 ?"bg-green-500": "bg-red-500"
            }`}
            style={{ width: `${data.success_rate}%` }}
          />
        </div>
        <div className="text-right text-xs text-gray-500 mt-1">
          {data.success_rate}% success
        </div>
      </div>

      {/* Toggle */}
      <button
        onClick={() => setShowDetails((prev) => !prev)}
        className="mt-3 text-xs text-blue-600 hover:underline"
      >
        {showDetails ? "Hide Details" : "View Details"}
      </button>

      {/* Detailed Results */}
      {showDetails && (
        <div className="mt-3 space-y-3 max-h-64 overflow-y-auto">
          {data.test_results.map((test, index) => (
            <div
              key={index}
              className="border rounded-xl p-3 text-sm bg-gray-50 space-y-2"
            >
              <div className="flex justify-between items-center">
                <span className="font-medium truncate w-52">
                  {test.test_name}
                </span>
                <span
                  className={`text-lg font-bold ${
                    test.is_correct ? "text-green-500" : "text-red-500"
                  }`}
                >
                   {test.is_correct ? "✓" : "✗"}
                </span>
              </div>

              <div className="flex justify-between text-xs text-gray-500">
                <span>Execution: {test.execution_time.toFixed(4)}s</span>
                {test.error_message && (
                  <span className="text-red-500">
                    Error: {test.error_message}
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function Stat({ label, value, color }) {
  return (
    <div className="text-center">
      <div
        className={`font-semibold ${
          color === "green"
            ? "text-green-600"
            : color === "red"
            ? "text-red-600"
            : "text-gray-800"
        }`}
      >
        {value}
      </div>
      <div className="text-xs text-gray-500">{label}</div>
    </div>
  );
}


